<script>
export default {
  name: 'FaviconKaik',
  props: {
    dosts: {
      type: String,
      default: '#664CFD',
    },
    box: {
      type: String,
      default: '#EEEEEE',
    },
  },

}
</script>
<template>
  <svg width="53" height="53" viewBox="0 0 53 53" fill="none" xmlns="http://www.w3.org/2000/svg">
    <g filter="url(#filter0_i_2528_817)">
      <rect width="52.8477" height="52.8477" rx="14.1556" :fill="`url(#paint0_linear_2528_817)`" />
      <path
        d="M12.7931 16.6598C12.3801 13.7686 14.431 11.0944 17.3838 10.673C20.3366 10.2515 23.0828 12.2424 23.5306 15.1281C23.9823 18.0386 21.9267 20.7525 18.9493 21.1772C15.9718 21.6018 13.2096 19.575 12.7931 16.6598Z"
        :fill="dosts" />
      <path
        d="M29.3041 16.6415C28.9089 13.7407 30.9371 11.0677 33.8372 10.6672C36.7373 10.2667 39.414 12.2901 39.8197 15.1894C40.2265 18.0962 38.1968 20.7814 35.2893 21.1828C32.3818 21.5844 29.7004 19.5499 29.3041 16.6415Z"
        :fill="dosts" />
    </g>
    <defs>
      <filter id="filter0_i_2528_817" x="0" y="-1.85113" width="53.7732" height="54.6988" filterUnits="userSpaceOnUse"
        color-interpolation-filters="sRGB">
        <feFlood flood-opacity="0" result="BackgroundImageFix" />
        <feBlend mode="normal" in="SourceGraphic" in2="BackgroundImageFix" result="shape" />
        <feColorMatrix in="SourceAlpha" type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          result="hardAlpha" />
        <feOffset dx="0.925566" dy="-1.85113" />
        <feGaussianBlur stdDeviation="2.84612" />
        <feComposite in2="hardAlpha" operator="arithmetic" k2="-1" k3="1" />
        <feColorMatrix type="matrix" values="0 0 0 0 0.821162 0 0 0 0 0.824367 0 0 0 0 0.828853 0 0 0 0.25 0" />
        <feBlend mode="normal" in2="shape" result="effect1_innerShadow_2528_817" />
      </filter>
      <linearGradient id="paint0_linear_2528_817" x1="48.8177" y1="4.55088" x2="26.4238" y2="30.0438"
        gradientUnits="userSpaceOnUse">
        <stop stop-color="white" />
        <stop offset="1" :stop-color="box" />
      </linearGradient>
    </defs>
  </svg>
</template>